(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qishen-quote-request-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-qishen-quote-form]');
    if (!form) return;

    var button = form.querySelector('[data-qishen-quote-submit]');
    if (!button) return;

    button.classList.add('qishen-quote-request__submit--pending');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
  });

  window.addEventListener('DOMContentLoaded', function () {
    var confirmation = document.querySelector('[data-qishen-quote-success]');
    if (!confirmation) return;

    confirmation.scrollIntoView({ block: 'center' });
    confirmation.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
